import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 1l-8.31 8.31 8.31 8.3zM4.91 4.36L3.5 5.77l6.36 6.37L1 21h17.73l2 2 1.41-1.41z"
}), 'SignalCellularOffSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellularOffSharp.js
// module id = 6201
// module chunks = 2